<div class="area-of-interest-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title class="dialog-title">
      {{ 'common.areaOfInterest.label' | translate }}
    </h2>
  </div>

  <div class="dialog-header-divider"></div>

  <mat-dialog-content class="dialog-content">
    <div class="chips-section">
      @if (loadingExisting) {
        <div class="loading-existing">
          <mat-progress-spinner
            diameter="24"
            mode="indeterminate"
            color="primary"
            strokeWidth="3"
          ></mat-progress-spinner>
        </div>
      }
      <educare-chips-autocomplete
        [searchFn]="searchAreaOfInterest"
        [selectedItems]="selectedItems"
        [isItemRemovable]="isItemRemovableFn"
        [placeholder]="'common.areaOfInterest.placeholder' | translate"
        [allowCustomEntry]="true"
        [emitIdsOnly]="false"
        (emitSelectedOptions)="onSelected($event)"
        class="auto-chips-div"
      >
      </educare-chips-autocomplete>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="submitting">
      {{ 'actions.cancel' | translate }}
    </button>
    <button type="button" class="btn-confirm" (click)="onConfirm()" [disabled]="submitting">
      <span *ngIf="!submitting">{{ 'actions.confirm' | translate }}</span>
      <span *ngIf="submitting">{{ 'snackbar.assigning' | translate }}</span>
    </button>
  </div>
</div>
